export default __webpack_public_path__ + "static/media/icon.1c1e30de.png";